import { differenceInDays } from 'date-fns';

import { Dateable } from '../types';

const daysBetween = (endDate: Dateable, startDate: Dateable): number =>
  differenceInDays(endDate, startDate);

export default daysBetween;
